// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-list[data-v-e8ed5e88] {
  position: relative;
}
.dialer-link[data-v-e8ed5e88] {
  transform: scale(0.8);
}
#dialer-link svg[data-v-e8ed5e88] {
  fill: var(--fill-color);
}
#dialer-link svg[data-v-e8ed5e88]:hover {
  fill: var(--toolbtn-color-hover);
}
#dialer-link.disabled[data-v-e8ed5e88] {
  cursor: initial;
}
#dialer-link.disabled svg[data-v-e8ed5e88] {
  fill: var(--icon-disabled-color);
}
#dialer-link.disabled svg[data-v-e8ed5e88]:hover {
  fill: var(--icon-disabled-color);
}
.circle-animation.disabled[data-v-e8ed5e88] {
  cursor: initial;
}
.circle-animation.disabled svg[data-v-e8ed5e88] {
  fill: var(--icon-disabled-color);
}
.circle-animation.disabled svg[data-v-e8ed5e88]:hover {
  fill: var(--icon-disabled-color);
}
.conference[data-v-e8ed5e88] {
  color: var(--toolbtn-color);
}
.conference.disabled[data-v-e8ed5e88] {
  cursor: initial;
}
.conference.disabled i[data-v-e8ed5e88] {
  color: var(--icon-disabled-color);
}
.conference.disabled i[data-v-e8ed5e88]:hover {
  color: var(--icon-disabled-color);
}
.call-list-item[data-v-e8ed5e88] {
  align-items: center;
}
.call-list-item[data-v-e8ed5e88]:hover {
  background-color: var(--list-item-bghover);
}
.call-list-item .info-block[data-v-e8ed5e88] {
  flex: 1 1;
  overflow: hidden;
}
.call-list-item .info-block > *[data-v-e8ed5e88] {
  height: 1.5em;
}
.call-list-item .info-block > * > *[data-v-e8ed5e88] {
  margin: auto 0;
}
.call-list-item .info-block .fio[data-v-e8ed5e88] {
  font-size: var(--titleFontSize);
  filter: contrast(var(--fontContrast));
  max-height: var(--titleMaxHeight);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.call-list-item .info-block .type[data-v-e8ed5e88] {
  font-size: var(--subTitleFontSize);
  filter: contrast(var(--fontContrast));
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.call-list-item .info-block .type img[data-v-e8ed5e88] {
  height: 15px;
}
.call-list-item .info-block .type .phone-img[data-v-e8ed5e88] {
  height: 12px;
}
.call-list-item .info-block .type .phone-img-missed-dark[data-v-e8ed5e88] {
  height: 12px;
  opacity: 0.6;
}
.call-list-item .info-block .type span[data-v-e8ed5e88] {
  margin-left: 6px;
  color: var(--chat-text-color);
  vertical-align: middle;
}
.call-list-item .info-block .type .redFont[data-v-e8ed5e88] {
  color: var(--elem-red-color);
}
.call-list-item .right-section[data-v-e8ed5e88] {
  display: flex;
  flex-direction: column;
  font-size: .8em;
  filter: contrast(var(--fontContrast));
  color: var(--chat-text-color);
}
.call-list-item .right-section > *[data-v-e8ed5e88] {
  margin: auto 0;
}
.call-list-item .right-section .count[data-v-e8ed5e88] {
  margin-top: 3px;
  height: 18px;
  width: 18px;
  align-self: end;
}
.call-list-item .right-section .count span[data-v-e8ed5e88] {
  height: 18px;
  width: 18px;
  background: var(--elem-red-color);
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 9px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
}
.call-list-item .right-section .time[data-v-e8ed5e88] {
  height: 1.4em;
  color: var(--chat-time-color);
}
.call-list-item .right-section .whiteFont[data-v-e8ed5e88] {
  background: #FFFFFF;
}
.call-list-item .right-section .redFont[data-v-e8ed5e88] {
  color: var(--elem-red-color);
}
ul.list li .hor-line[data-v-e8ed5e88] {
  width: calc(100% - 68px);
  margin-left: 68px;
}
.conference[data-v-e8ed5e88] {
  color: var(--toolbtn-color);
  padding: 0px 0px 0px 5px;
}
.conference[data-v-e8ed5e88] :hover {
  color: var(--toolbtn-color-hover);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/side/CallsList.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,iCAAiC;AACnC","sourcesContent":[".call-list[data-v-e8ed5e88] {\n  position: relative;\n}\n.dialer-link[data-v-e8ed5e88] {\n  transform: scale(0.8);\n}\n#dialer-link svg[data-v-e8ed5e88] {\n  fill: var(--fill-color);\n}\n#dialer-link svg[data-v-e8ed5e88]:hover {\n  fill: var(--toolbtn-color-hover);\n}\n#dialer-link.disabled[data-v-e8ed5e88] {\n  cursor: initial;\n}\n#dialer-link.disabled svg[data-v-e8ed5e88] {\n  fill: var(--icon-disabled-color);\n}\n#dialer-link.disabled svg[data-v-e8ed5e88]:hover {\n  fill: var(--icon-disabled-color);\n}\n.circle-animation.disabled[data-v-e8ed5e88] {\n  cursor: initial;\n}\n.circle-animation.disabled svg[data-v-e8ed5e88] {\n  fill: var(--icon-disabled-color);\n}\n.circle-animation.disabled svg[data-v-e8ed5e88]:hover {\n  fill: var(--icon-disabled-color);\n}\n.conference[data-v-e8ed5e88] {\n  color: var(--toolbtn-color);\n}\n.conference.disabled[data-v-e8ed5e88] {\n  cursor: initial;\n}\n.conference.disabled i[data-v-e8ed5e88] {\n  color: var(--icon-disabled-color);\n}\n.conference.disabled i[data-v-e8ed5e88]:hover {\n  color: var(--icon-disabled-color);\n}\n.call-list-item[data-v-e8ed5e88] {\n  align-items: center;\n}\n.call-list-item[data-v-e8ed5e88]:hover {\n  background-color: var(--list-item-bghover);\n}\n.call-list-item .info-block[data-v-e8ed5e88] {\n  flex: 1 1;\n  overflow: hidden;\n}\n.call-list-item .info-block > *[data-v-e8ed5e88] {\n  height: 1.5em;\n}\n.call-list-item .info-block > * > *[data-v-e8ed5e88] {\n  margin: auto 0;\n}\n.call-list-item .info-block .fio[data-v-e8ed5e88] {\n  font-size: var(--titleFontSize);\n  filter: contrast(var(--fontContrast));\n  max-height: var(--titleMaxHeight);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.call-list-item .info-block .type[data-v-e8ed5e88] {\n  font-size: var(--subTitleFontSize);\n  filter: contrast(var(--fontContrast));\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.call-list-item .info-block .type img[data-v-e8ed5e88] {\n  height: 15px;\n}\n.call-list-item .info-block .type .phone-img[data-v-e8ed5e88] {\n  height: 12px;\n}\n.call-list-item .info-block .type .phone-img-missed-dark[data-v-e8ed5e88] {\n  height: 12px;\n  opacity: 0.6;\n}\n.call-list-item .info-block .type span[data-v-e8ed5e88] {\n  margin-left: 6px;\n  color: var(--chat-text-color);\n  vertical-align: middle;\n}\n.call-list-item .info-block .type .redFont[data-v-e8ed5e88] {\n  color: var(--elem-red-color);\n}\n.call-list-item .right-section[data-v-e8ed5e88] {\n  display: flex;\n  flex-direction: column;\n  font-size: .8em;\n  filter: contrast(var(--fontContrast));\n  color: var(--chat-text-color);\n}\n.call-list-item .right-section > *[data-v-e8ed5e88] {\n  margin: auto 0;\n}\n.call-list-item .right-section .count[data-v-e8ed5e88] {\n  margin-top: 3px;\n  height: 18px;\n  width: 18px;\n  align-self: end;\n}\n.call-list-item .right-section .count span[data-v-e8ed5e88] {\n  height: 18px;\n  width: 18px;\n  background: var(--elem-red-color);\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 9px;\n  color: #FFFFFF;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 1px;\n}\n.call-list-item .right-section .time[data-v-e8ed5e88] {\n  height: 1.4em;\n  color: var(--chat-time-color);\n}\n.call-list-item .right-section .whiteFont[data-v-e8ed5e88] {\n  background: #FFFFFF;\n}\n.call-list-item .right-section .redFont[data-v-e8ed5e88] {\n  color: var(--elem-red-color);\n}\nul.list li .hor-line[data-v-e8ed5e88] {\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\n.conference[data-v-e8ed5e88] {\n  color: var(--toolbtn-color);\n  padding: 0px 0px 0px 5px;\n}\n.conference[data-v-e8ed5e88] :hover {\n  color: var(--toolbtn-color-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
